import { getSessionToken } from './sessionTokenService';

interface CheckListLimitResponse {
  canCreateList: boolean;
  currentCount: number;
  maxAllowed: number;
}

interface CheckTickerLimitResponse {
  canAddTicker: boolean;
  currentCount: number;
  maxAllowed: number;
}

class UsageLimitsApiService {
  private baseUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/v1/usage-limits`;

  private async makeRequest<T>(endpoint: string): Promise<T> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    // Add session token to all requests
    const sessionToken = getSessionToken();
    const headers: Record<string, string> = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
    if (sessionToken) {
      headers['X-Session-Token'] = sessionToken;
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async checkListLimit(): Promise<CheckListLimitResponse> {
    return this.makeRequest<CheckListLimitResponse>('/list-limit');
  }

  async checkTickerLimit(): Promise<CheckTickerLimitResponse> {
    return this.makeRequest<CheckTickerLimitResponse>('/ticker-limit');
  }
}

export const usageLimitsApi = new UsageLimitsApiService();
